module.exports = "/_next/static/images/CartAbandonmentDesktop-d94d74735940b0018e9a148333ddd750.png";